import React from 'react';
import Seo from './Seo';
import { LastUpdated } from './LastUpdated';
import { Link } from 'react-router-dom';
import './ProductPage.css';
import './ContentPage.css';

const ProductPage: React.FC = () => {
    const productJsonLd = {
        "@context": "https://schema.org",
        "@type": "Product",
        "@id": "https://miaoshili.com/product/#product",
        "name": "视觉功能训练治疗软件",
        "productID": "浙械注准20252211724",
        "model": "SKMS-VTS-01 / SKMS-VTS-02",
        "category": "第二类医疗器械",
        "brand": {"@type": "Brand", "name": "妙视力"},
        "manufacturer": {"@id": "https://miaoshili.com/#organization"},
        "description": "注册资料载明的适用范围为儿童轻、中度弱视及融合功能不足的治疗；注册资料载明的功能包括精细刺激训练、视觉技巧训练和双眼视功能训练。",
        "url": "https://miaoshili.com/product/"
    };

    return (
        <div className="product-page">
            <Seo
                title="产品与资质｜视觉功能训练治疗软件（浙械注准20252211724）"
                description="妙视力产品与资质信息：弱视/斜视训练系统、动画片训练课程；注册产品名称为视觉功能训练治疗软件，注册人为杭州深康明视科技有限公司，注册证编号为浙械注准20252211724。"
                canonical="https://miaoshili.com/product/"
                jsonLd={[productJsonLd]}
            />
            <div className="product-page-bg">
                {/* Main Content */}
                <main className="product-main">
                    <h1 className="sr-only">妙视力产品与资质</h1>
                    <div className="product-banner">
                        <img src="/product/product_page_title.webp" alt="妙视力产品介绍" width={"35%"}/>
                    </div>

                    {/* product 1 */}
                    <div className="product-section">
                        <img src="/product/product_1.webp" alt="妙视力产品介绍图1" width={"97%"}/>
                    </div>

                    {/* product 2 */}
                    <div className="product-section">
                        <img src="/product/product_2.webp" alt="妙视力产品介绍图2" width={"94%"}/>
                    </div>

                    {/* product 3 */}
                    <div className="product-section">
                        <img src="/product/product_3.webp" alt="妙视力产品介绍图3" width={"80%"}/>
                    </div>

                    {/* product 4 */}
                    <div className="product-section">
                        <img src="/product/product_4.webp" alt="妙视力产品介绍图4" width={"85%"}/>
                    </div>
                    <div className="product-section">
                        <img src="/product/product_5.webp" alt="妙视力产品介绍图5" width={"100%"}/>
                    </div>

                    {/* 产品与资质信息（原 /product/qualification 页面内容并入） */}
                    <section className="qualification-section" id="qualification">
                        <div className="qualification-header">
                            <h2>产品与资质</h2>
                            <p className="qualification-subtitle">权威注册认证 · 专业值得信赖</p>
                        </div>
                        <div className="qualification-body">
                            <p>妙视力是杭州深康明视科技有限公司研发、生产的视觉训练产品品牌。本页集中展示注册产品信息、医疗器械资质与相关服务说明，供用户了解与核验。</p>

                            <h3>一、注册产品信息</h3>
                            <table className="qualification-table">
                                <thead>
                                    <tr><th scope="col">项目</th><th scope="col">内容</th></tr>
                                </thead>
                                <tbody>
                                    <tr><th scope="row">注册产品名称</th><td>视觉功能训练治疗软件</td></tr>
                                    <tr><th scope="row">注册人</th><td>杭州深康明视科技有限公司</td></tr>
                                    <tr><th scope="row">医疗器械注册证编号</th><td>浙械注准 20252211724</td></tr>
                                    <tr><th scope="row">管理类别</th><td>第二类医疗器械</td></tr>
                                    <tr><th scope="row">注册证有效期</th><td>至 2030-09-15</td></tr>
                                    <tr><th scope="row">注册证载明型号</th><td>SKMS-VTS-01、SKMS-VTS-02</td></tr>
                                </tbody>
                            </table>
                            <p className="content-note">上述信息以医疗器械注册证载明内容为准，用户可通过国家药品监督管理局官方数据查询渠道核验。</p>

                            <h3>二、适用范围</h3>
                            <p>注册证载明的适用范围为：适用于儿童轻、中度弱视及融合功能不足的治疗。</p>

                            <h3>三、注册资料载明的功能</h3>
                            <p>现有医疗器械注册资料载明的功能包括以下三项：</p>
                            <ul className="function-list">
                                <li><strong>精细刺激训练</strong> —— 围绕视觉精细辨别能力设计的训练内容。</li>
                                <li><strong>视觉技巧训练</strong> —— 围绕视觉技巧相关能力设计的训练内容。</li>
                                <li><strong>双眼视功能训练</strong> —— 围绕双眼协同与视功能相关能力设计的训练内容。</li>
                            </ul>
                            <p className="content-note">各训练模块的具体内容、参数设置与操作方式，以产品功能为准。</p>

                            <h3>四、产品型号与使用终端</h3>
                            <p>注册证载明型号为 SKMS-VTS-01 与 SKMS-VTS-02。用户可通过妙视力 App 下载和使用软件，具体支持的系统版本与设备要求，以官方下载页面公布信息为准。</p>

                            <h3>五、服务说明</h3>
                            <p>用户购买后，按订单约定开通相应期限的软件服务；部分套餐可包含大屏相关设备，具体组成以购买页面和订单为准。</p>
                            <p>用户可获得 1V1 专属服务群支持，每位用户建立独立服务群，由服务团队协作提供使用指导、日常答疑、训练提醒及根据实际训练记录提供的后续服务。</p>
                            <p className="content-note">其中「1V1」指每位用户对应一个独立专属服务群、由团队协同提供服务，不代表由固定一名人员全程服务。</p>

                            <h3>六、关于适用与不适用</h3>
                            <p>本产品的适用范围以注册证载明内容为准。是否需要采用、以及训练频次与周期如何安排，建议在专业机构的检查与指导下，结合儿童具体情况确定。</p>
                            <p>本页内容用于产品与资质信息展示，不构成诊疗建议，也不替代医疗机构的诊断与治疗。</p>

                            <h3>七、相关资质</h3>
                            <p>除医疗器械注册证外，杭州深康明视科技有限公司还持有以下资质：</p>
                            <table className="qualification-table">
                                <thead>
                                    <tr><th scope="col">资质名称</th><th scope="col">编号</th></tr>
                                </thead>
                                <tbody>
                                    <tr><td>医疗器械生产许可证</td><td>浙药监械生产许 20250123 号</td></tr>
                                    <tr><td>第二类医疗器械经营备案</td><td>浙杭药监械经营备 20262295 号</td></tr>
                                    <tr><td>互联网药品信息服务备案</td><td>浙网药信备字〔2026〕00151 号</td></tr>
                                    <tr><td>计算机软件著作权登记证书</td><td>软著登字第 16422745 号</td></tr>
                                </tbody>
                            </table>
                            <p className="content-note">上述证照的具体范围与当前状态，以主管部门最新公开信息为准。</p>

                            <h3>八、关于主体关系</h3>
                            <p>杭州深康明视科技有限公司负责妙视力相关产品的研发、生产及资质管理；杭州趣瞳视光科技有限公司经授权承担部分渠道的市场推广、代理销售和商业运营。</p>

                            <h3>九、资质核验路径</h3>
                            <p>用户可通过以下渠道自行核验：</p>
                            <ul className="verify-list">
                                <li>国家药品监督管理局医疗器械数据查询（<a href="https://www.nmpa.gov.cn/" target="_blank" rel="noopener noreferrer">https://www.nmpa.gov.cn/</a>）</li>
                                <li>本网站「官方渠道」页提供的官方联系方式</li>
                            </ul>

                            <h3>十、相关内容</h3>
                            <ul className="related-list">
                                <li><Link to="/about/brand-and-company/">企业与品牌</Link>：了解公司主体与授权分工</li>
                                <li><Link to="/faq/">常见问题</Link>：查看购买、使用与服务的常见问答</li>
                                <li><Link to="/download/">下载软件</Link>：获取官方下载入口</li>
                            </ul>
                        </div>
                    </section>

                    <LastUpdated/>
                </main>
            </div>
        </div>
    );
};

export default ProductPage;
